import React from 'react';
import PropTypes from 'prop-types';
import FeaturesCompareHeader from './FeaturesCompareHeader';
import FeaturesCompareTable from './FeaturesCompareTable';

class FeaturesCompare extends React.Component {
  render() {
    const {
      columns,
      headers,
      featureGroups,
      defaultSections,
      disclaimer,
      lockDefaultColumn,
      placeholderText,
      analyticsKey,
      onSelect,
      onSectionsChange
    } = this.props;

    return (
      <div className="features-compare">
        <FeaturesCompareHeader
          headers={headers}
          lockDefaultColumn={lockDefaultColumn}
          placeholderText={placeholderText}
          disclaimer={disclaimer}
          analyticsKey={analyticsKey}
          onSelect={onSelect}
        />
        <FeaturesCompareTable
          featureGroups={featureGroups}
          columns={columns}
          defaultSections={defaultSections}
          analyticsKey={analyticsKey}
          onSectionsChange={onSectionsChange}
        />
      </div>
    );
  }
}

FeaturesCompare.propTypes = {
  columns: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  featureGroups: PropTypes.object.isRequired,
  defaultSections: PropTypes.array,
  disclaimer: PropTypes.string,
  lockDefaultColumn: PropTypes.bool,
  placeholderText: PropTypes.string,
  analyticsKey: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onSectionsChange: PropTypes.func.isRequired
};

export default FeaturesCompare;
